module.exports = __webpack_public_path__ + "img/sup_withdraw_vega2.c5397658.jpg";